/**
 * Included into the footer of pages.
 */

import * as variables from './variables';

import './lib/AnimationEasing';

import "./lib/AnalyticsSetup";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import { MainMenu } from './component/MainMenu';
new MainMenu({
	menuID: 'menu',
	toggles: '.menuToggle',
	focusLock: {
		dialog: '.menu',
		return: '.menuToggle--open',
		toggle: '.menuToggle--close'
	},
	styleClass: {
		menuOpen: 'hasMenuOpen'
	},
	duration: 400,
	easing: 'easeOutExpo'
});

// Colorbox
import './lib/Colorbox';

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});


// ==================================================================
// Animations -> InViewObserver.ts
// Notes:
// 		selectors are a little convoluted
// 		body:not(.page-id-276) = not contact page
//
// ==================================================================
import InViewObserver from './component/InViewObserver';
InViewObserver.createInstance([
	{
		observeSelector: 'body:not(.page-id-276) .pageContent > *',
		minimum: 20,
		minimumUnit: "px"
	},
	{
		observeSelector: '.acf-grid-listing',
		minimum: 20,
		minimumUnit: "px"
	},
]);
//===================================================================
